import React, { Component } from 'react';
import styled from 'styled-components';
import * as tokens from '@trp-rps-rps-shared-web/rps-shared-web-styles';
import ReactModalHeader from '../Modal/ReactModalHeader';
import ReactModalContent from '../Modal/ReactModalContent';

const StyledText = styled.div`
  font-family: Nimbus Sans Regular;
  font-size: 20px;
  line-height: 26px;
  letter-spacing: -0.5px;
  color: ${tokens.ColorGrey900};
  margin: 32px 0 24px;
  @media (max-width: 768px) {
    font-size: 16px;
    line-height: 22px;
    color: ${tokens.ColorGrey800};
    margin: 24px 0 0;
  }
`;

class DollarValue extends Component<any, any> {
  render(): JSX.Element {
    return (
      <React.Fragment>
        <ReactModalHeader modalTitle={'Dollar Value'} showClose={true} />
        <ReactModalContent>
          <StyledText>
            Today’s dollars and future dollars are different ways of illustrating the value of money over time.
            <br />
            <br />
            Today&apos;s dollars describe how much a projected amount, which includes assumptions about growth and
            inflation, is worth today. In calculating today&apos;s dollars, we discount inflation growth to illustrate
            the current value of future dollars.
            <br />
            <br />
            Future dollars describe projected growth over time, including projected inflation.
          </StyledText>
        </ReactModalContent>
      </React.Fragment>
    );
  }
}

export default DollarValue;
